export default __webpack_public_path__ + "static/media/FAVICON_23.9f6502db.png";